export default "__VITE_ASSET__BpKHOvr1__"